export const Marquee = ({ t }) => {
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="marquee-section" className="relative overflow-hidden border-y border-white/10 bg-[#0C1018] py-5">
      <div className="marquee-track flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display px-8 text-lg italic text-slate-400 sm:text-xl">{item}</span>
            <span className="text-amber-400">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
